import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-horizontal.png'


const _withScopeId = n => (_pushScopeId("data-v-751a6ba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left py-2 px-2 flex flex-col items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo flex flex-col items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-gris120" }, "Resumen de pago", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}